// Preset for every "notify customer" switch on a purchase. Mirrors
// Purchase::notifiesPurchaser() in the API: false for marketplace orders (Otto),
// whose customer communication the marketplace owns. Staff can still notify by
// switching it on; an order loaded without the field notifies as before.
export const notifiesPurchaserByDefault = (purchase) => purchase?.notify_purchaser !== false;
